<template>
  <app-modal
    v-model="isDialogOpened"
    data-locator="ai-assistant-help-center-modal"
    size="lg"
    @cancel="closeDialog"
  >
    <template #title>
      <div class="ai-assistant-modal__title my-6">{{ modalTitle }}</div>
    </template>
    <template #body>
      <div class="ai-assistant-modal__body d-flex flex-column row-gap-6 px-6">
        <template v-if="displayMorePromptHelp">
          <p>{{ $t(`${TRANSLATION_KEY_PREFIX}.morePromptHelp.contentIntro`) }}</p>
          <div class="d-flex flex-column row-gap-1">
            <template v-for="(paragraph,index) in $tm(`${TRANSLATION_KEY_PREFIX}.morePromptHelp.content`)" :key="index">
              <div :class="{ 'font-weight-bold': (index as number) % 2 === 0 }">{{ paragraph }}</div>
            </template>
          </div>
          <div>
            <p class="font-weight-bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.morePromptHelp.exampleTitle`) }}</p>
            <template v-for="(paragraph,index) in $tm(`${TRANSLATION_KEY_PREFIX}.morePromptHelp.exampleContent`)" :key="index">
              <p>{{ paragraph }}</p>
            </template>
          </div>
          <div>
            <p class="font-weight-bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.morePromptHelp.tipTitle`) }}</p>
            <p>{{ $t(`${TRANSLATION_KEY_PREFIX}.morePromptHelp.tipContent`) }}</p>
          </div>
        </template>
        <template v-else>
          <template v-for="link in links" :key="link.name">
            <div class="link-group d-flex align-center" :data-locator="`${link.dataLocator}-link-group`">
              <div class="link-group__content">
                <p class="font-weight-bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.list.${link.name}.title`) }}</p>
                <p>{{ $t(`${TRANSLATION_KEY_PREFIX}.list.${link.name}.description`) }}</p>
              </div>
              <app-button class="ml-auto" :data-locator="`${link.dataLocator}-link-button`" @click="link.action">
                {{ $t(`${TRANSLATION_KEY_PREFIX}.list.${link.name}.buttonLabel`) }}
              </app-button>
            </div>
          </template>
        </template>
      </div>
    </template>
    <template #footer>
      <div v-if="displayMorePromptHelp" class="ai-assistant-modal__footer d-flex column-gap-4 justify-center">
        <app-button class="app-button" @click="closeDialog">
          {{ $t('common.close') }}
        </app-button>
      </div>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { dialogMixin } from '@/mixins/dialogMixin'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantHelpCenterModal'

export default {
  name: 'AIAssistantHelpCenterModal',
  mixins: [dialogMixin],
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
      displayMorePromptHelp: false,
    }
  },
  computed: {
    modalTitle() {
      return this.displayMorePromptHelp
        ? this.$t(`${TRANSLATION_KEY_PREFIX}.morePromptHelp.title`)
        : this.$t(`${TRANSLATION_KEY_PREFIX}.title`)
    },
    links () {
      return [
        {
          action: () => this.closeDialog(),
          dataLocator: 'start-tour',
          name: 'startTour',

        },
        {
          action: () => this.showMorePromptHelp(),
          dataLocator: 'learn-more',
          name: 'learnMore',
        },
        {
          action: () => this.openFAQ(),
          dataLocator: 'faq',
          name: 'faq',
        },
      ]
    },
  },
  methods: {
    openFAQ() {
      const faqUrl = 'https://www.lexisnexis.com/supportandtraining/fr/closd/b/closd-legal-project/posts/comment-utiliser-protege-dans-closd' // French only FAQ
      window.open(faqUrl, '_blank')
    },
    showMorePromptHelp() {
      this.displayMorePromptHelp = true
    },
  },
}
</script>

<style scoped lang="scss">
.ai-assistant-modal__title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}
.ai-assistant-modal__body, .ai-assistant-modal__footer {
  font-size: 16px;
  line-height: 24px;
  p{
    margin: 0;
  }
  .link-group__content {
    max-width: 375px;
  }

  .app-button {
    font-weight: bold;
    font-size: 16px;

    &:not(:disabled), &:focus {    
      background-color: rgb(var(--v-theme-purple-darken-1));
      color: white !important;

      &:hover, &:active {
        background-color: #5F39AC !important;
      }
    }
  }
}
</style>